import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlResolverService } from 'app/common/url-resolver.service';
import { Observable } from 'rxjs';
import { isNil, omitBy } from 'lodash';
import { BCompany, TCompanyData, TCompanyParams, TCompanyUpdateResponse } from './company';
import { map } from 'rxjs/operators';
import { SimplePage } from 'app/common/types';
import { Ajax } from 'app/common/ajax';

@Injectable()
export class CompanyService {
  private readonly URL: string;

  constructor(private http: HttpClient, urlResolverService: UrlResolverService) {
    this.URL = urlResolverService.misApiUrlForPath('/company');
  }

  get(params: TCompanyParams): Observable<SimplePage<BCompany>> {
    return this.http
      .get<SimplePage<BCompany>>(this.URL, {
        ...Ajax.X_NO_LOADING_OPTIONS,
        params: omitBy(params, isNil),
      })
      .pipe(
        map((response) => {
          response.records = BCompany.fromRestArray(response.records);
          return response;
        })
      );
  }

  create(data: TCompanyData): Observable<void> {
    return this.http.post<void>(this.URL, omitBy(data, isNil));
  }

  edit(data: TCompanyData): Observable<TCompanyUpdateResponse> {
    return this.http.put<TCompanyUpdateResponse>(this.URL, omitBy(data, isNil));
  }
}
